import {observable, action, computed, runInAction, reaction} from 'mobx';
import Api from '../../services/api';
import {IBuilding} from "../../types/IBuilding";
import languagesStore from "../LanguagesStore/LanguagesStore";

class BuildingsStore {
    @observable public building?: IBuilding;
    @observable public multiBuildings?: IBuilding[];

    constructor() {
        reaction(()=>this.building, ()=>{
            languagesStore.setAvailableIETFs(this.buildingAvailableLanguages);
            languagesStore.setDefaultIETF(this.building?.lang);
        });
    }

    @action
    public getBuildingById = async (id: string|number|undefined) => {
        if(!id)
        {
            this.building = undefined;
            return;
        }

        try {
            const building = await Api.getBuildingById(id.toString());
            runInAction(() => {
                this.building = building;
            });
        } catch(e) {
            console.log(e);
        }
    };

    @action
    public getMultiBuildings = async (idx: string[]) => {
        try {
            const multiBuildings = await Api.getMultiBuildings(idx);
            runInAction(() => {
                this.multiBuildings = multiBuildings;
            });
        } catch(e) {
            console.log(e);
        }
    };

    @computed
    public get buildingAvailableLanguages() {
        if(!this.building)
            return [];

        const mobileLangs = this.building.buildingMobileLanguages.map(l => l.ietf);
        return [...mobileLangs, this.building.lang];
    };

    @computed
    public get buildingLogo() {
        if(!this.building)
            return '';

        const host = `${location.protocol}//${location.hostname}${location.port?':'+location.port:''}`;
        const appUrl = process.env.REACT_APP_API_URL // defaults to /api
        const appUrlIsRelative = appUrl?.startsWith("/")
        const finalUrl = `${appUrlIsRelative ? `${host}${appUrl}` : appUrl}/Storages/building-${this.building.id}/download/${this.building.buildingLogo}`

        return finalUrl;
    }

    @computed
    public get addressWithoutCountry(){
        if(!this.building?.address_google)
            return '';

        const lastCommaIndex = this.building.address_google.lastIndexOf(',');
        return this.building.address_google.substr(0, lastCommaIndex);
    }

    @computed
    public get googleMapsLink(){
        if(!this.building?.address_google)
            return '';

        return `https://www.google.com/maps/search/?api=1&query=${encodeURI(this.building.address_google)}`
    }
}

const buildingsStore = new BuildingsStore();

export default buildingsStore;
